/**
 * SidebarSubnavigationOther
 */
import * as React from 'react';

// Styles
import './styles.scss';

interface Props {
    children: React.Node;
}

export default class SidebarSubnavigationOther extends React.Component<
    Props,
    State
> {
    shouldComponentUpdate() {
        return false;
    }

    render() {
        const { children } = this.props;
        return <div className="sidebar-subnavigation-other">{children}</div>;
    }
}
